var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "SSRAgTable",
        _vm._g(
          {
            attrs: {
              frameworkComponents: _vm.frameworkComponents,
              columns: _vm.columnDefsList,
              data: _vm.rowData,
              totalRows: _vm.totalRows,
              totalPages: _vm.totalPages,
              isLoading: _vm.isLoading,
              columnFilters: _vm.columnFilters,
              isExportable: true,
              onExport: _vm.exportExcel,
              page: _vm.currentPage,
            },
            on: {
              fetchData: _vm.getGridData,
              updateSelectedItems: _vm.onSelectedItems,
              searchQuery: function ($event) {
                _vm.searchQuery = $event
              },
            },
          },
          _vm.$listeners
        )
      ),
      _c("show-docs-popup", {
        attrs: {
          modalActive: _vm.modalActive,
          poModalData: _vm.poModalData,
          title: "Pagos",
          variant: "payment",
          currencies: _vm.currencies,
        },
        on: {
          "update:modalActive": function ($event) {
            _vm.modalActive = $event
          },
          "update:modal-active": function ($event) {
            _vm.modalActive = $event
          },
          updatePurchaseOrders: _vm.updatePurchaseOrders,
          "update:currencies": function ($event) {
            _vm.currencies = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }